import { createSelector } from '@reduxjs/toolkit';

import { TIME_24_FORMAT, TIME_AM_PM_FORMAT } from 'src/shared/constants';
import {
  DepartmentDisplayFormatEnums,
  DurationFormatEnums,
  LanguageEnums,
  TimeFormatEnums,
  WeekDaysEnums,
} from 'src/shared/enums';
import { RootState } from 'src/store/types';

const selectSelf = (state: RootState) => state.user;
const selectLocalizations = (state: RootState) => state.localizations;

export const getLanguagePreferenceId = createSelector(selectSelf, ({ preferences }) => {
  return preferences?.languageId || LanguageEnums.EN;
});

export const isESS = createSelector(selectSelf, ({ info }) => {
  return info?.employeeId !== undefined && info?.employeeId !== null;
});

export const getPhoneMask = createSelector(selectSelf, ({ settings }) => {
  return settings?.phoneMaskString || '(###) ###-####';
});

export const getFirstDayOfWeek = createSelector(selectSelf, ({ preferences }) => {
  return preferences?.firstDayOfWeek || WeekDaysEnums.SUNDAY;
});

export const getTimeFormat = createSelector(selectSelf, ({ preferences }) => {
  switch (preferences?.timeFormat) {
    case TimeFormatEnums.T_DECIMAL:
      return undefined;
    case TimeFormatEnums.T_12_HOURS:
      return TIME_AM_PM_FORMAT;
    case TimeFormatEnums.T_24_HOURS:
    default:
      return TIME_24_FORMAT;
  }
});

export const getTimeFormatId = createSelector(selectSelf, ({ preferences }) => {
  return preferences?.timeFormat || TimeFormatEnums.T_12_HOURS;
});

export const hasCriticalError = createSelector(
  [selectSelf, selectLocalizations],
  ({ infoError, settingsError, preferencesError }, { error: localizationsError }) => {
    return !!(infoError || settingsError || preferencesError || localizationsError);
  },
);

export const getEssApiVersion = createSelector(selectSelf, ({ apiVersion }) => {
  return apiVersion;
});

export const getDurationFormat = createSelector(selectSelf, ({ preferences }) => {
  return preferences?.durationFormat ?? DurationFormatEnums.T_24_HOURS;
});

export const getEmployeeDepartmentDisplayFormat = createSelector(selectSelf, ({ preferences }) => {
  return preferences?.departmentNameFormat ?? DepartmentDisplayFormatEnums.NUMBER_DESCRIPTION;
});
